export const UPDATE_EMAIL_ADDRESS ='UPDATE_EMAIL_ADDRESS';

export const CHANGE_EMAIL_ERROR ='CHANGE_EMAIL_ERROR';

export const FORCE_SIGN_OUT ='FORCE_SIGN_OUT';

export const LAST_VERIFICATION_CODE_SENT='LAST_VERIFICATION_CODE_SENT';
